/**
 * @enum UiId
 *
 * Represents all unique UI element identifiers within the application.
 *
 * Each enum key corresponds to a specific reusable component
 * (atom, molecule, organism, or template), while its value
 * defines a **semantic, lowercase identifier**.
 *
 * This enum can be used as a reliable reference for:
 * - Loading or mapping UI translations
 * - Tracking component usage (analytics, telemetry)
 * - Maintaining consistent identifiers across design and code
 *
 * Example:
 * ```ts
 * import { UiId } from '@ts/enums/UiId'
 *
 * const t = translations[UiId.Footer]?.sign_in_button
 * // -> 'Comienza hoy'
 * ```
 */
export enum UiId {
  IntendedAudience = 'intended-audience',
  AuthCallToAction = 'auth-call-to-action',
  TopicCard = 'topic-card',
  SearchArticles = 'search-articles',
  SupportSection = 'support-section',
  FaqQuestions = 'faq-questions',
  Layout = 'layout',
}
